import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const schedule = {
    path: '/schedules',
    component: Layout,
    name: 'schedules',
    redirect: '/schedules/index',
    children: [
      {
        path: '/schedules/index',
        component: () => import('@/views/schedule/index'),
        name: 'schedules.index',
        meta: { title: i18n.t(`message.graphic`)}
      },
    ]
  }

export default schedule
